module.exports = __webpack_public_path__ + "img/arrow_back_envi_ios.ca527d0a.svg";